/**
 * @fileoverview Enum object representation of the valid possible steps of the Listings Launch flow.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */
export const ListingsLaunchStep = Object.freeze({
  PUBLISHER_SETUP: 0,
  MATCH_ENTITY: 1,
  VERIFICATION: 2,
});

export const ListingsLaunchStepByValue = Object.freeze(
  Object.fromEntries(
    Object.entries(ListingsLaunchStep).map(([key, value]) => [value, key]),
  ),
);
